export default "__VITE_ASSET__ea7e648e__"